const layout = [
  {
    name: 'zero',
    breakpoint: 0,
    pageOffset: 16,
    layoutOffset: 16,
    gridGutter: 12,
    gridColumns: 6,
  },
  {
    name: 'small',
    breakpoint: 480,
    pageOffset: 16,
    layoutOffset: 16,
    gridGutter: 12,
    gridColumns: 6,
  },
  {
    name: 'medium',
    breakpoint: 768,
    pageOffset: 32,
    layoutOffset: 32,
    gridGutter: 24,
    gridColumns: 12,
  },
  {
    name: 'large',
    breakpoint: 1024,
    pageOffset: 48,
    layoutOffset: 48,
    gridGutter: 24,
    gridColumns: 12,
  },
  {
    name: 'wide',
    breakpoint: 1280,
    pageOffset: 48,
    layoutOffset: 48,
    gridGutter: 24,
    gridColumns: 12,
    maxWidth: 1184,
  },
  {
    name: 'ultra',
    breakpoint: 1440,
    pageOffset: 90,
    layoutOffset: 42,
    gridGutter: 32,
    gridColumns: 12,
    maxWidth: 1440,
  },
  {
    name: 'panoramic',
    breakpoint: 1920,
    pageOffset: 90,
    layoutOffset: 42,
    gridGutter: 32,
    gridColumns: 12,
    maxWidth: 1440,
  },
];

const reducer = (key: keyof LayoutProp) =>
  layout.reduce((acc: any, item: LayoutProp) => {
    acc[item.name] = item[key];
    return acc;
  }, {});

const breakpoints = reducer('breakpoint');
const pageOffsets = reducer('pageOffset');
const layoutOffsets = reducer('layoutOffset');
const gridGutters = reducer('gridGutter');
const gridColumns = reducer('gridColumns');
const maxWidths = reducer('maxWidth');

export interface LayoutProp {
  name: string;
  breakpoint: number;
  pageOffset: number;
  layoutOffset: number;
  gridGutter: number;
  gridColumns: number;
  maxWidth?: number;
}

export {
  layout,
  breakpoints,
  pageOffsets,
  layoutOffsets,
  gridGutters,
  gridColumns,
  maxWidths,
};
